import { Add, GridView } from "@mui/icons-material";
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";

const Installers = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span>{path}</span>
                </div>
                <Link to="create">
                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                </Link>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default Installers;
